import React from "react";
import { MapPin, Briefcase, TrendingUp, Clock, ArrowUpRight } from "lucide-react";
import { GlassCard } from "@/components/primitives";
import { cn } from "@/lib/utils";

const Tag = ({ icon: Icon, children }) => (
  <span className="inline-flex items-center gap-1.5 rounded-full border border-white/[0.08] bg-white/[0.03] px-3 py-1 text-xs font-medium text-axor-white/70">
    <Icon className="h-3.5 w-3.5 text-axor-cyan" />
    {children}
  </span>
);

export const JobCard = ({ job, onView, className }) => (
  <GlassCard
    className={cn("group flex cursor-pointer flex-col p-7", className)}
    onClick={() => onView(job)}
    data-testid={`job-card-${job.id}`}
  >
    <div className="flex items-start justify-between gap-4">
      <div>
        <span className="text-xs font-bold uppercase tracking-[0.18em] text-axor-cyan">
          {job.industry}
        </span>
        <h3 className="mt-2 text-2xl font-semibold tracking-tight text-axor-white">
          {job.title}
        </h3>
      </div>
      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-white/10 bg-white/[0.03] text-axor-white transition-[background-color,transform] duration-300 group-hover:bg-axor-cyan group-hover:text-axor-hero">
        <ArrowUpRight className="h-5 w-5" />
      </span>
    </div>

    <p className="mt-4 flex-1 text-sm leading-relaxed text-axor-text">
      {job.summary}
    </p>

    <div className="mt-6 flex flex-wrap gap-2">
      <Tag icon={MapPin}>{job.location}</Tag>
      <Tag icon={Briefcase}>{job.type}</Tag>
      <Tag icon={TrendingUp}>{job.experience}</Tag>
    </div>

    <button
      className="mt-6 inline-flex items-center gap-1.5 self-start text-sm font-semibold text-axor-cyan transition-colors hover:text-axor-turquoise"
      data-testid={`job-view-${job.id}`}
      onClick={(e) => {
        e.stopPropagation();
        onView(job);
      }}
    >
      View Opportunity
      <ArrowUpRight className="h-4 w-4" />
    </button>
  </GlassCard>
);
